import { Instance } from 'mobx-state-tree'
import { TeachingTableCtaModelBase } from './TeachingTableCtaModel.base'

/* The TypeScript type of an instance of TeachingTableCtaModel */
export interface TeachingTableCtaModelType extends Instance<typeof TeachingTableCtaModel.Type> {}

/* A graphql query fragment builders for TeachingTableCtaModel */
export {
  selectFromTeachingTableCta,
  teachingTableCtaModelPrimitives,
  TeachingTableCtaModelSelector
} from './TeachingTableCtaModel.base'

/**
 * TeachingTableCtaModel
 */
export const TeachingTableCtaModel = TeachingTableCtaModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
